import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["cellType", "label"];
import React from "react";
import Typography from "../../../../Typography";
import { BaseHeaderCell } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function HeaderCell(_ref) {
  var cellType = _ref.cellType,
    label = _ref.label,
    props = _objectWithoutProperties(_ref, _excluded);
  var textAlign = cellType === "number" ? "right" : "left";
  var alignContent = cellType === "number" ? "end" : null;
  return /*#__PURE__*/_jsx(BaseHeaderCell, {
    alignContent: alignContent,
    children: /*#__PURE__*/_jsx(Typography, _extends({
      variant: "inherit",
      color: "inherit",
      textAlign: textAlign
    }, props, {
      children: label
    }))
  });
}
export default HeaderCell;